import { LogLevel } from "@azure/msal-browser";

const TENANT_ID = 'ce0dcde7-6c07-4bab-9b59-b122c9934e28';

// Determine client ID based on environment
const getClientId = () => {
    const env = process.env.REACT_APP_ENV;
    console.log('REACT_APP_ENV:', env);
    console.log('NODE_ENV:', process.env.NODE_ENV);
    
    if (env === 'dev') {
        console.log('Using DEV client ID');
        return '7b9576df-ecf5-48f6-ba0c-37d6e7320a3f';
    } else if (env === 'test') {
        console.log('Using TEST client ID');
        return '24823f1e-2d90-4ff8-9fc3-f811b30f2cb7';
    } else {
        console.log('Using PROD client ID');
        return '9f61c05a-4fe7-4a4e-a954-9b05b5f3278e'; // production
    }
};

export const msalConfig = {
    auth: {
        clientId: getClientId(),
        authority: `https://login.microsoftonline.com/${TENANT_ID}/v2.0`,
        redirectUri: `${window.location.origin}/auth`,
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) return;
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            }
        }
    }
};

export const loginRequest = {
    scopes: ["openid", "profile", "email", "offline_access"]
};

export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
    graphPhotoEndpoint: "https://graph.microsoft.com/v1.0/me/photo/$value"
};
